import { ContainerType } from "./container-type-enum";
import { LabMDM } from "../../masterdata/models/lab";
import { PlateOrientation } from "./plate-orientation-enum";
import { ContainerItem } from "./container-item";

export class Container {

	_id :string;
	containerType:ContainerType;

	/** The barcode. */
	 barcode:string;

	/** The scan result file name. */
	  scanResultFileName:string;

	/** The scan date. */
	  scanDate:Date;

	/** The orientation. */
	  orientation:PlateOrientation;

	/** The carrier items. */
	containerItems: ContainerItem[] ;

	/** The lab. */
	 lab:LabMDM;

	/** The scan complete date. */
	 scanCompleteDate:Date;

	 containerState: string;

	 creationDate:Date;

	 wellType: string;

	 storageLocationOfContainer: string;

	 processStep:string;

	 processState:string;

}